import gql from 'graphql-tag';

export const CONTACT_MUTATION = gql`
  mutation saveContact($contact: ContactInput!) {
    saveContact(contact: $contact) {
      id
             jobTitle
             fullName
             firstName
             lastName
             isContractor
             isEngineer
             isHomeowner
             isInspector
             emailAddress1
             emailAddress2
             telephone1
             telephone1sms
             telephone2
             telephone2sms
             address1_Line1
             address1_Line2
             address1_City
             address1_StateOrProvince
             address1_PostalCode
             familyStatusCode
             businessName
             address2_Telephone1
             address2_Line1
             address2_Line2
             address2_City
             address2_StateOrProvince
             address2_PostalCode
             address2_Latitude
             address2_Longitude
             address3_Line1
             address3_Line2
             address3_City
             address3_StateOrProvince
             address3_PostalCode
             address3_Latitude
             address3_Longitude
             webSiteUrl
             contractorLicenseNumber
             contractorLicenseExpiration
             contractorInDirectory
             essContractorInDirectory
             emrContractorInDirectory
             advertiseYourself
             femaTrained
             essFemaTrained
             emrFemaTrained
             personalizationDashboardHome
             dashboardTour
             contractorLicenseIsValid
             hasReview
    }
  }
`;

export const CONTACT_HO_MUTATION = gql`
  mutation saveHomeownerContact($contact: ContactInput!) {
    saveHomeownerContact(contact: $contact) {
      id
      jobTitle
      firstName
      lastName
      fullName
      telephone1
      telephone1sms
      telephone2
      telephone2sms
      address1_Line1
      address1_Line2
      address1_City
      address1_StateOrProvince
      address1_PostalCode
      familyStatusCode
      businessName
      emailAddress2
      address2_Telephone1
      address2_Line1
      address2_Line2
      address2_City
      address2_StateOrProvince
      address2_PostalCode
      address2_Latitude
      address2_Longitude
      contractorLicenseNumber
      webSiteUrl
      advertiseYourself
    }
  }
`;

export const CONTACT_COOWNER_MUTATION = gql`
  mutation saveDwelling($dwellingInput: DwellingInput!, $dwellingId: String) {
    saveDwelling(dwelling: $dwellingInput, dwellingId: $dwellingId) {
      id
      address_Street
      address_Street_Line2
      address_City
      address_State
      address_Zip
      yearBuilt
      coownerFirstName
      coownerLastName
      coownerEmail
      coownerPhone
      coownerPhoneSMS
      ownerAssociation
      numberOfUnits
      squareFootage
    }
  }
`;

export const CONTACT_LDP_MUTATION = gql`
  mutation saveLdpContact($contact: ContactInput!) {
    saveLdpContact(contact: $contact) {
      id
      fullName
      firstName
      lastName
      emailAddress1
      emailAddress2
      telephone1
      telephone1sms
      telephone2
      telephone2sms
      address1_Line1
      address1_Line2
      address1_City
      address1_StateOrProvince
      address1_PostalCode
      ldpLicenseType
      ldpLicenseNumber
      ldpLicenseExpiration
      address2_Line1
      address2_Line2
      address2_City
      address2_StateOrProvince
      address2_PostalCode
    }
  }
`;

export const CONTACT_CONTRACTOR_MUTATION = gql`
  mutation saveContractorContact($contact: ContactInput!) {
    saveContractorContact(contact: $contact) {
      id
      salutation
      fullName
      firstName
      lastName
      jobTitle
      emailAddress1
      telephone1
      telephone1sms
      telephone2
      telephone2sms
      address1_Line1
      address1_Line2
      address1_City
      address1_StateOrProvince
      address1_PostalCode
      businessName
      address2_Line1
      address2_Line2
      address2_City
      address2_StateOrProvince
      address2_PostalCode
      howdidyouhearaboutusType
      howdidyouhearaboutusOther
      webSiteUrl
      contactType
      contractorLicenseExpiration
      contractorLicenseNumber
      contractorLicenseType
      insured
      bonded
      contractorClassifications
      contractorLicenseIsValid
    }
  }
`;

export const CONTACT_CONTRACTOR_UNLISTED_MUTATION = gql`
  mutation saveContractorUnlisted($contact: ContactInput!) {
    saveContractorUnlisted(contact: $contact) {
      id
      fullName
      firstName
      lastName
      emailAddress1
      telephone1
      businessName
      contactType
      contractorLicenseExpiration
      contractorLicenseNumber
      contractorLicenseType
      insured
      bonded
      contractorClassifications
      contractorLicenseIsValid
      address2_Line1
      address2_Line2
      address2_City
      address2_StateOrProvince
      address2_PostalCode
      address3_Line1
      address3_Line2
      address3_City
      address3_StateOrProvince
      address3_PostalCode
      contractorManualEntry
      contractorInDirectory
      createdOn
    }
  }
`;
export const CONTACT_LDP_UNLISTED_MUTATION = gql`
  mutation saveLdpUnlisted($contact: ContactInput!) {
    saveLdpUnlisted(contact: $contact) {
      id
      fullName
      firstName
      lastName
      emailAddress1
      telephone1
      businessName
      contactType
      ldpLicenseType
      ldpLicenseNumber
      ldpLicenseExpiration
      address2_Line1
      address2_Line2
      address2_City
      address2_StateOrProvince
      address2_PostalCode
      address3_Line1
      address3_Line2
      address3_City
      address3_StateOrProvince
      address3_PostalCode
      ldpManualEntry
      createdOn
    }
  }
`;